<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
//table封装组件
//table封装组件
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import UPDATE from '@/components/page/update.vue'
import DataUtil from '@/views/mis/util/data'
import download from '@/utils/download'
//接口地址url的统一管理
import URL from '@/views/newmis36/util/url'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import axios from 'axios'

let relationType = { 0: '客户', 1: '直接', 2: '间接' }
let demo = { 0: '真实', 1: '模拟' }
let levelType = { 'MIN': '迷你', 'STD': '标准', 'PLA': '铂金' }
let symbolType = { '2': '外汇', '1': '贵金属', '5': '指数', '4': '商品', '-1': '不限产品', '100': '非虚拟币', '7': '股票', '6': '货币' }
let activeNameList = {}
let nationality = { 'ISO_3166_704': '越南', 'ISO_3166_356': '印度' }
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },
  mounted() {
    this.axios.post(URL.rebateActivity.queryAll, Qs.stringify({ activeType: 1 })).then(res => {
      console.log(res)
      if (res.code == 0) {
        for (let i in res.result) {
          activeNameList[res.result[i].activeId] = res.result[i].activeName
        }
      }
      console.log(activeNameList)
    })
  },
  methods: {
    checkbox(row) {
      this.deleteIds = row.map(key => key.id).join(',')
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'update') {
        this.$refs.childUpdate.open(row)
      }
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if ('查询' == clickName || window.$t('txmis.bt.query') == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if (window.$t('txmis.bt.down') == clickName) {
        //隐藏关键字段
        const param = Object.assign(JSON.parse(JSON.stringify(data)), { exportHide: true })
        download.exportExcel(URL.tradingRebate.downloadTradeDetails, param, window.$t('txmis.rewardTradeDetails.downloadTradeDetails'))
      } else if (window.$t('txmis.bt.export') == clickName) {
        const param = Object.assign(JSON.parse(JSON.stringify(data)), {})
        download.exportExcel(URL.tradingRebate.downloadTradeDetails, param, window.$t('txmis.rewardTradeDetails.downloadTradeDetails'))
      }
    },
    /*新增或跟提交数据触发事件*/
    submit(model) {
      //根据是否包含id更新还是添加
      this.dataChanage('', model, res => {
        if (res.data.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('suc')
        } else {

        }
      })
    },
    dataChanage(url, option, suc, fail) {
      this.axios.post(url, Qs.stringify(option || {})).then(res => {

        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }
  },
  data() {
    return {
      deleteIds: '',
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: window.$t('txmis.common.startTime'), field: 'beginDate', type: 5 },
          { title: window.$t('txmis.common.endTime'), field: 'endDate', type: 5 },
          { title: window.$t('txmis.rewardTradeDetails.currentCustomerNumber'), field: 'currentCustomerNumber' },
          { title: window.$t('txmis.rewardTradeDetails.currentMobilePhone'), field: 'currentMobilePhone' },
          { title: window.$t('txmis.rewardTradeDetails.excuteCustomerNumber'), field: 'excuteCustomerNumber' },
          { title: window.$t('txmis.rewardTradeDetails.mobilePhone'), field: 'mobilePhone' },
          {
            title: window.$t('txmis.rewardTradeDetails.relationType'),
            field: 'relationType',
            type: 2,
            optionList: relationType,
            isNumber: true
          },
          {
            title: window.$t('txmis.relationList.nationality'),
            field: 'nationality',
            type: 2,
            optionList: nationality
          },
          { title: '返利类型', field: 'actType', data: 1, hidden: true },
          { click: window.$t('txmis.bt.query') },
          { click: window.$t('txmis.bt.down') },
          { click: window.$t('txmis.bt.export') }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: URL.tradingRebate.tradeDetailsList, //请求路径和参数
        selection: true,
        sequence: true,
        cols: [
          { title: window.$t('txmis.rewardTradeDetails.currentCustomerNumber'), field: 'currentCustomerNumber' },
          { title: window.$t('txmis.rewardTradeDetails.currentMobilePhone'), field: 'currentMobilePhone' },
          {
            title: '活动名称', field: 'activeId', render: (data, full) => {
              return activeNameList[data]
            }
          },
          { title: window.$t('txmis.rewardTradeDetails.currentChineseName'), field: 'currentChineseName' },
          { title: window.$t('txmis.rewardTradeDetails.excuteCustomerNumber'), field: 'excuteCustomerNumber' },
          {
            title: window.$t('txmis.relationList.nationality'), field: 'excuteNationality', render: (data, full) => {
              return nationality[data]
            }
          },
          { title: window.$t('txmis.rewardTradeDetails.mobilePhone'), field: 'mobilePhone' },
          {
            title: window.$t('txmis.rewardTradeDetails.demo'), field: 'demo', render: (data, full) => {
              return demo[data] || ''
            }
          },
          {
            title: window.$t('txmis.rewardTradeDetails.levelType'), field: 'levelType', render: (data, full) => {
              return levelType[data] || ''
            }
          },
          { title: window.$t('txmis.accountReward.activeId'), field: 'activeId' },
          {
            title: window.$t('txmis.rewardTradeDetails.symbolType'), field: 'symbolType', render: (data, full) => {
              return symbolType[data] || ''
            }
          },
          { title: window.$t('txmis.rewardTradeDetails.symbol'), field: 'symbol' },
          { title: window.$t('txmis.rewardTradeDetails.orderid'), field: 'orderid' },
          { title: window.$t('txmis.rewardTradeDetails.execVolume'), field: 'execVolume' },
          {
            title: window.$t('txmis.rewardTradeDetails.relationType'), field: 'relationType', render: (data, full) => {
              return relationType[data] || ''
            }
          },
          { title: window.$t('txmis.rewardTradeDetails.directPhone'), field: 'directPhone' },
          { title: window.$t('txmis.rewardTradeDetails.indirectPhone'), field: 'indirectPhone' },
          { title: window.$t('txmis.rewardTradeDetails.currentRebete'), field: 'currentRebete' },
          {
            title: window.$t('txmis.rewardTradeDetails.ctime'), field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          }
        ]
      }
    }
  }
}
</script>
